const navigation = {
  nav: {
    home: "Начало",
    about: "За Нас",
    services: "Услуги",
    testimonials: "Доволни Пациенти",
    gallery: "Галерия",
    contact: "Контакти",
  },
  servicesMenu: {
    trigger: "Услуги",
    allServices: "Всички Услуги",
  },
  serviceLinks: {
    implantology: {
      name: "Имплантология",
      description: "Висококачествени, дълготрайни зъбни импланти",
    },
    endodontics: {
      name: "Ендодонтия",
      description: "Модерно лечение на коренови канали",
    },
    "oral-surgery": {
      name: "Орална Хирургия",
      description: "Прецизни орално-хирургични процедури",
    },
    periodontology: {
      name: "Пародонтология",
      description: "Специализирано лечение на венците",
    },
    orthodontics: {
      name: "Ортодонтия",
      description: "Експертно лечение на зъбен неправилен захапка",
    },
    bonding: {
      name: "Бондинг",
      description: "Козметични поправки със зъбен цвят композит",
    },
    prosthetics: {
      name: "Протетика",
      description: "Персонализирани мостове и протези",
    },
    cariesology: {
      name: "Кариесология",
      description: "Превенция и лечение на кариес",
    },
    "teeth-whitening": {
      name: "Избелване на Зъби",
      description: "Професионално избелване за по-ярка усмивка",
    },
    "dental-tourism": {
      name: "Дентален Туризъм",
      description: "Цялостни дентални пакети за международни пациенти",
    },
    prices: {
      name: "Ценоразпис",
      description: "Актуални ориентировъчни цени по услуги",
    },
  },
};

export default navigation;
